// extracted by mini-css-extract-plugin
export default {"index-message-main":"IndexMessage_index-message-main__dkPXW"};